import type { ResourceFAQItem } from '@/lib/data/resources';

export default function ResourceFAQSection({ faqs }: { faqs: ResourceFAQItem[] }) {
    return (
        <div className="not-prose mt-10 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold mb-5">Frequently Asked Questions</h2>
            <div className="space-y-6">
                {faqs.map((faq) => (
                    <div key={faq.question}>
                        <h3 className="font-semibold text-lg text-gray-900 mb-1">{faq.question}</h3>
                        <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
